import state from './staffState'
import mutations from './staffMutations'
import actions from './staffActions'
import getters from './staffGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
